import styled from 'styled-components';

export const StyledSpinner = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  
  & img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  
  & svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    animation: spin 1s linear infinite;
  }
  
  & circle {
    stroke-width: 2;
    stroke-dasharray: 60, 20;
    fill: none;
    stroke: #EE4B81;
    cx: 50%;
    cy: 50%;
    r: 18px;
  }
  
  @keyframes spin { 
    100% { 
      transform: rotate(360deg);
    }
  }
`;
